module.exports = __webpack_public_path__ + "img/outsideWx.2a7a951a.png";